import React from 'react';
import { AppSidebar } from '../../components/AppSidebar';

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <AppSidebar />
      <div className="ml-64 min-h-screen">
        <main className="relative">
          <div className="container mx-auto px-6 py-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout; 